<template>
 
        <div class="main_back">           
            <div style="background: #5cadff;width:100%; ">
                <div style="height:50px;margin-top:3px;display :flex">
                    <img style="height:40px;margin-right:10px;color:#5cadff;margin-top:5px;"   src="@/assets/title.png"/>
                    <div style="color:#2d8cf0;font-weight: 700;font-size: 20px;line-height:50px;color:white;margin-top:3px; ">找回密码</div>
                </div>
            </div>
            <div class="step">
                找回密码
            </div>
            <div style=" margin-top:10px ">
                <el-steps :active="active" align-center space="100%">
                    <el-step title="账号输入" icon="el-icon-user-solid"></el-step>
                    <el-step title="验证身份" icon="el-icon-s-check"></el-step>
                    <el-step title="重置密码" icon="el-icon-setting"></el-step>
                </el-steps>
            </div>
 
            <div v-if="active===1" style="margin-top:30px;">
                <el-input v-enter-number placeholder="请输入手机号" v-model="phoneno"  style="width:350px;margin-left:10px;vertical-align:center">
 
                    <el-select  v-model="area" slot="prepend" style="width:160px; " placeholder="请选择">
                        <el-option  label="中国大陆 0086" value="0086" ></el-option>         
                        <el-option  label="中国香港 0852" value="0852" ></el-option>
                        <el-option  label="中国澳门 0853" value="0853" ></el-option> 
                    </el-select>                       
                </el-input> 
                <div style="margin-top:25px;">
                    <el-button type="primary" @click="nextStep" style="width:350px;margin-left:10px;">下一步</el-button>
                </div>
            </div>
            <div v-if="active===2" style="margin-top:30px;"> 
                <div style="margin-top:25px;">              
                    <el-input placeholder="手机号码"  v-model="phoneno"  style="width:340px;margin-left:10px;" readonly></el-input> 
                </div>
                <div style="margin-top:25px;  "> 
                    <el-input placeholder="输入6位手机短信校验码" v-model="validmsg"  style="width:205px;margin-left:10px;"></el-input> 
 
                    <el-button v-show="sendAuthCode" type="primary" style="width:130px;margin-left:4px;" @click="getAuthCode">发送验证码</el-button>
                    <el-button disabled v-show="!sendAuthCode" type="primary" style="width:130px;margin-left:4px;" >{{auth_time}}秒后重新发送</el-button>
                </div>              
                <div style="margin-top:35px; ">
                    <el-button type="primary" @click="nextStep2" style="width:340px;margin-left:10px;">下一步</el-button>
                </div>
            </div>
            <div v-if="active===3" style="margin-top:30px;">                                                                    
                <el-input v-model="userno" placeholder="用户名" readonly style="width:350px;margin-left:10px;" >  
                    <el-button icon="el-icon-user" style="background:#F2F6FC"></el-button>                   
                </el-input>
 
                <div style="margin-top:20px;">
                    <el-input
                        type="password"
                        placeholder="请输入新密码(长度不少于6位)"
                        autofocus=true
                        show-password
                        v-model="password"
                        style="width:350px;margin-left:10px;"
                    >
                        <el-button slot="prepend" icon="el-icon-lock" style="background:#F2F6FC"></el-button>
                    </el-input>
                </div>
                <div style="margin-top:20px;">
                    <el-input
                        type="password"
                        placeholder="请确认新密码(长度不少于6位)"
                        v-model="cfmpassword"
                        show-password
                        style="width:350px;margin-left:10px;"
                    >
                        <el-button slot="prepend" icon="el-icon-lock" style="background:#F2F6FC"></el-button>
                    </el-input>  
                </div>            
                <div style="margin-top:25px;">
                    <el-button type="primary" @click="nextStep3" style="width:350px;margin-left:10px;">完成</el-button>
                </div>
            </div>
        </div>
 
</template>

<script>
import { getBaseData } from '@/api/user'
 
    export default {
        name: "ForgetPwd",
        
        data () {
            return {
                active: 1,
                phoneno:'',
                sendAuthCode:true,/*布尔值，通过v-show控制显示 获取按钮 还是 倒计时  */
                auth_time: 0, 
                area:'',
                validmsg:'', //校验码
                idseq:'',
                userno:'',
                password:'',
                cfmpassword:'',
         
 
                tabCol:[],
            }
        },
        watch: {
 
        },
        mounted() {
            this.area ='0086'
            
        },
        methods: {
            // 第一步
            nextStep(){ 
                //手机号判断
                if (this.phoneno){
                    getBaseData( 'xuper_auth/getTableRecMany','telno',this.phoneno,'','','V_sys_user').then((res)=>{
                        if (res.result.length===0){
                            this.$alert('此手机号码没有绑定登录账号', '提示', {
                                confirmButtonText: '确定',
                                showClose:false,
                                type:'info'
                            })
                        }else{
                            this.active =this.active+1;
                        }
                    });
                }else{
                    this.$alert('请输入手机号码', '提示', {
                        confirmButtonText: '确定',
                        showClose:false,
                        type:'info'
                    })
                }
            },
            // 第二步
            nextStep2(){
                this.btnMsg()
            },
            // 第三步
            nextStep3(){
                this.pwdSave()
            },
            //修改密码
            pwdSave(){ 
                let pwd_ =this.password
                let cfmpwd_=this.cfmpassword
                if (!pwd_){
                    this.$Message.error('新密码不能为空')
                }else if (!cfmpwd_){
                    this.$Message.error('确认密码不能为空')
                }else{
                    if(pwd_.length<6){
                        this.$Message.error('密码长度不能少于6位')
                    }else if(cfmpwd_.length<6){
                        this.$Message.error('确认密码长度不能少于6位')
                    }else if(pwd_!==cfmpwd_){
                        this.$Message.error('新密码和确认密码不匹配,请核查')
                    }else{
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/updatePassword',
                            data: {p_value:this.phoneno, p_table:'sys_user',p_value2:pwd_},
                        }).then(res=>{      
                            if(res.result ==='OK')  {          
                                this.$router.replace('/login'); 
                            }else{
                                this.$alert(res.result, '提示', {
                                    confirmButtonText: '确定',
                                    showClose:false,
                                    type:'info'
                                })
                            }        
                        }) 
                    }         
                }
            },
            //短信登录
            btnMsg() {
                if (!this.validmsg){
                    this.$Message.error('输入短信校验码')
                }else {
                    //短信验证码 10分钟有效 及合法性判断
                    this.$axios({
                        method:'post', 
                        url: 'xuper_auth/forgetMessage' ,
                        data:{  //get这里应为params //请求参数
                            telno :this.phoneno,
                            code :this.validmsg,
                        },
                    }).then(res =>{
                        if (res.code === '200'){
                            this.active =this.active+1;
                            this.userno =res.usernm
                            this.idseq =res.idseq
                        }else{
                            this.$alert(res.message, '提示', {
                                confirmButtonText: '确定',
                                showClose:false,
                                type:'info'
                            })
                        }
                    }) 

                }
            },
            //获取验证码
            getAuthCode() {
                if (!this.phoneno){
                    this.$Message.error('请输入手机号码')
                }else {
                    let area_ =this.area==='0086'?'china':'foreign'
                    //消息验证
                    this.$axios({
                        method:'post', 
                        url: 'xuper_auth/sendMessage' ,
                        data:{  //get这里应为params //请求参数
                            telno :this.phoneno,
                            area :area_,
                            areano:this.area
                        },
                    }).then(res =>{
                        if (res.code === 'OK'){
                            this.sendAuthCode = false;
                            this.auth_time = 60;
                            var auth_timetimer =  setInterval(()=>{
                                this.auth_time--;
                                if(this.auth_time<=0){
                                    this.sendAuthCode = true;
                                    clearInterval(auth_timetimer);
                                }
                            }, 1000);
                        }else{
                            this.$alert(res.message, '提示', {
                                confirmButtonText: '确定',
                                showClose:false,
                                type:'info'
                            })
                        }
                    }) 
                }
            },
        }
    }
</script>

<style scoped>

.step{
    color:rgb(94, 94, 153);
    font-size:18px;
    font-weight:600; 
    margin-top:15px;
    margin-bottom: 5px;
    padding-left:10px;
    text-align: left;
}
.rowline{
    width:250px;
    margin-left:10px;
    margin-top:20px;
}
.main_back{
    background:#f7f8ff;
    margin:100px auto;  
    width:50%;
    border:1px solid #fff;
    height:500px;
    text-align:center;
}
</style>
